import { c as _c } from "react/compiler-runtime";
import { ReactNode } from 'react';
import { AuthLeftPanel } from './AuthLeftPanel';
import { AuthRightPanel } from './AuthRightPanel';
type AuthLayoutProps = {
  children: ReactNode;
  maxWidth?: string;
  subHeader?: ReactNode;
};
const AuthLayout = t0 => {
  const $ = _c(7);
  const {
    children,
    maxWidth,
    subHeader
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== maxWidth || $[2] !== subHeader) {
    t1 = <AuthLeftPanel maxWidth={maxWidth} subHeader={subHeader}>{children}</AuthLeftPanel>;
    $[0] = children;
    $[1] = maxWidth;
    $[2] = subHeader;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <AuthRightPanel />;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1) {
    t3 = <div className="flex h-screen">{t1}{t2}</div>;
    $[5] = t1;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export { AuthLayout };